import React from 'react';
import { Box } from '../../styles/globalStyle';
import { Space } from 'antd';
import { theme, Text, ButtonAnt } from '@pfmam/pfmam';
import styled  from 'styled-components';
import { useSelector } from 'react-redux';
const GreyBox = styled(Box)`
  &.multi-cntct-mail-content {
    .ant-input-number-input {
      text-align: right;
      padding: 0 2520px;
    }
  }
  .field-wrapper {
    align-items: flex-start;
  }
`;
const OverrideButtonAnt = styled(ButtonAnt)`
  &&& {
    background: ${(props) => props.linkTextColor};
    color: white;
    margin-top: 15px;
    margin-left: 125px;
  }
`;
const TextSemibold = styled(Text)`
  font-family: 'Inter Semibold';
`;
export const NotAnMatchComponent = ({accountType,setStep }) => {
    const primary_color = useSelector((state) => state.siteInfo.primaryColor);

    const getInputTextLabel=()=>{
      if (accountType === 'wire') {
        return "No Wire ABA Match found.";
      } else if (accountType === 'ach') {
        return "No ACH ABA Match found.";
      } else {
        return "No match found.";
      }
    }
    return (
        <>
            <GreyBox
                boxcolor={primary_color}
                className="multi-cntct-mail-content">
                <Box
                    display="flex"
                    alignitems="center"
                    padding="24px 22px 14px"
                >
                </Box>
            </GreyBox>
            <Box margin="10px 50px 55px" className="forms">
            <TextSemibold
                    label={getInputTextLabel()}
                    lineheight="42px"
                    margin="0 50px 4px"
                    fontSize={`${theme.font_size.size_3xl}`}
                    color={`${theme.colors.black_secondary}`}
                />
                <Text
                    label={'Select Return to Search or reach out to the'}
                    fontSize={`${theme.font_size.size_2xl}`}
                    lineheight="42px"
                    color={`${theme.colors.black_secondary}`}
                />
                <Text
                    label={'Client Services Group for assistance.'}
                    fontSize={`${theme.font_size.size_2xl}`}
                    margin="0 20px 4px"
                    color={`${theme.colors.black_secondary}`}
                />
          <Space size={22}>
            <OverrideButtonAnt
                    linkTextColor={primary_color}  label="Return to Search" type="primary"
                    onClick={() => {
                        setStep(1);
                    }}
                />
            </Space>
          </Box>
        </>
    )
}